<app-header
    [langSel]="selectedLanguage"
    (selectedLanguage)="switchedLanguage($event)"
></app-header>
<div>
    <img
        src="/assets/images/CGC%20Dev%20Program%20imSME%20Banner-07.webp"
        class="tw-h-[100%] tw-w-[100%] tw-m-auto md:tw-m-0 sm:tw-m-auto sm:tw-mt-[10%]"
        alt="Banner"
    />
</div>
<div
    class="sm:tw-flex sm:tw-flex-col lg:tw-flex tw-flex-col tw-items-center sm:tw-items-center lg:tw-items-start lg:tw-flex-row tw-gap-[12vw] md:tw-gap-[5vw] 2xl:tw-gap-[2vw] tw-pt-[5rem] tw-pb-[2rem] sm:tw-pb-[2rem] lg:tw-pb-[3rem]"
>
    <div
        class="tw-max-w-[100%] sm:tw-max-w-auto lg:tw-max-w-[100%] tw-flex tw-flex-col lg:tw-px-[4vw]"
    >
        <div
            class="tw-w-full tw-text-center lg:tw-text-left tw-text-[24px] tw-text-[#212121] tw-font-bold lg:tw-font-semibold"
        >
            {{ "COMMON.CGC_PROGRAMME" | translate }}
        </div>
        <div
            class="tw-pl-[5vw] sm:tw-pl-[5vw] lg:tw-pl-[0vw] tw-pr-[5vw] sm:tw-pr-[5vw] lg:tw-pr-[0vw] tw-pt-[4vw] sm:tw-pt-[4vw] lg:tw-pt-[2vw] tw-w-[100%] lg:tw-w-[70%] tw-text-center sm:tw-text-center lg:tw-text-left tw-text-[#7E7E7E]"
        >
            {{ "CGC_DEV_PROG_PAGE.CGC_PROGRAMME_DESCRIPTION" | translate }}
        </div>
        <div class="tw-w-auto tw-mt-[2.5rem]">
            <iframe
                class="tw-hidden lg:tw-block tw-m-auto"
                width="963"
                height="504"
                src="https://www.youtube.com/embed/2aBRsvVB7lE?autoplay=1&mute=1"
                title="CGC Developmental Programme®"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
                referrerpolicy="strict-origin-when-cross-origin"
            ></iframe>
            <iframe
                class="tw-block lg:tw-hidden"
                width="350"
                height="183"
                src="https://www.youtube.com/embed/2aBRsvVB7lE?autoplay=1&mute=1"
                title="CGC Developmental Programme®"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
                referrerpolicy="strict-origin-when-cross-origin"
                style="margin: auto"
            ></iframe>
        </div>
    </div>
</div>

<div class="content tw-hidden lg:tw-flex sm:tw-hidden">
    <div fxLayout="row wrap" fxLayoutGap="16px grid">
        <div
            fxFlex="25%"
            fxFlex.xs="100%"
            fxFlex.sm="33%"
            *ngFor="let item of products; let i = index"
        >
            <mat-card>
                <mat-card-content>
                    <div
                        class="tw-mx-[20px] tw-my-[20px] tw-text-[24px] tw-font-semibold tw-text-left tw-w-auto tw-h-[60px]"
                    >
                        {{ item.title | translate }}
                    </div>
                    <div
                        class="tw-text-[14px] tw-text-[#616161] tw-font-medium tw-mx-[20px] tw-my-[20px] tw-text-left tw-h-[200px] tw-justify-between"
                    >
                        {{ item.description | translate }}
                        <span
                            *ngIf="
                                item?.title ==
                                'CGC_DEV_PROG_PAGE.NETWORKING_SESSION'
                            "
                        >
                            {{ item.description_1 | translate }}
                        </span>
                    </div>
                    <div class="tw-mb-3 tw-max-h-[175px] tw-h-auto">
                        <img
                            src="/assets/images/{{ item.title }}.png"
                            [alt]="item.title"
                            class="tw-mx-auto"
                        />
                    </div>
                    <div class="tw-flex tw-justify-center">
                        <button
                            type="submit"
                            (click)="openInfo(item.title, 'big')"
                            class="tw-bg-[#003262] tw-text-white tw-mt-4 tw-rounded-[32px] tw-font-semibold tw-py-[0.8rem] tw-w-[50%] tw-text-[18px]"
                        >
                            {{ "COMMON.READ_MORE" | translate }}
                        </button>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>

<div
    class="tw-flex sm:tw-flex lg:tw-hidden tw-container tw-m-auto tw-grid tw-grid-cols-1 tw-gap-5 lg:!tw-hidden tw-justify-start [&>*]:tw-py-[4vw] md:[&>*]:tw-p-[2vw]"
>
    <p-carousel
        [value]="products"
        [numVisible]="3"
        [numScroll]="1"
        [circular]="true"
        [responsiveOptions]="responsiveOptions"
        class="tw-w-auto overlay"
        autoplayInterval="5000"
    >
        <ng-template let-item pTemplate="item" class="overlay">
            <div
                class="tw-border-2 tw-rounded-3xl tw-m-2 tw-py-5 tw-px-3 tw-h-[100%] tw-shadow-[0_3px_10px_rgb(0,0,0,0.2)] tw-h-[98%] overlay"
            >
                <div
                    class="tw-mx-[20px] tw-my-[20px] tw-text-[24px] tw-font-semibold tw-text-left tw-w-auto tw-h-[60px]"
                >
                    {{ item.title | translate }}
                </div>
                <div
                    class="tw-text-[14px] tw-text-[#616161] tw-font-medium tw-mx-[20px] tw-my-[20px] tw-text-left tw-h-[200px] tw-justify-between"
                >
                    {{ item.description | translate }}
                    <span
                        *ngIf="
                            item?.title ==
                            'CGC_DEV_PROG_PAGE.NETWORKING_SESSION'
                        "
                    >
                        {{ item.description_1 | translate }}
                    </span>
                </div>
                <div class="tw-mb-3 tw-max-h-[175px] tw-h-auto">
                    <img
                        src="/assets/images/{{ item.title }}.png"
                        [alt]="item.title"
                        class="tw-mx-auto"
                    />
                </div>
                <div class="tw-flex tw-justify-center">
                    <button
                        type="submit"
                        (click)="openInfo(item.title, 'big')"
                        class="tw-bg-[#003262] tw-text-white tw-mt-4 tw-rounded-[32px] tw-font-semibold tw-py-[0.8rem] tw-w-[50%] tw-text-[18px]"
                    >
                        {{ "COMMON.READ_MORE" | translate }}
                    </button>
                </div>
            </div>
        </ng-template>
    </p-carousel>
</div>

<app-lndp-gallery-desktop
    *ngIf="imagesData.length"
    [imagesAW]="imageObjectAW"
    [imagesANM]="imageObjectANM"
    [imagesNS]="imageObjectNS"
    [imagesFA]="imageObjectFA"
/>
<app-lndp-gallery-mobile
    *ngIf="imagesData.length"
    [imagesAW]="imageObjectAW"
    [imagesANM]="imageObjectANM"
    [imagesNS]="imageObjectNS"
    [imagesFA]="imageObjectFA"
/>

<app-calendar-view
    class="tw-max-w-[100%] lg:tw-max-w-[100%] tw-flex tw-flex-col lg:tw-px-[4vw] tw-mb-[80px] tw-hidden md:tw-flex"
></app-calendar-view>
<app-calendar-view-mobile
    class="tw-flex tw-justify-center tw-my-10 md:tw-hidden"
/>
<div class="">
    <app-calendar-scroll-to-top [scrollTo]="1700" [minScroll]="2900" />
</div>
<app-footer></app-footer>
